import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

const BG = 'https://images.unsplash.com/photo-1766785368863-f2188a8c8b32?auto=format&fit=crop&w=1920&q=60';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!email.trim()) { toast.error('Enter your email address'); return; }
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${BG})` }} />
      <div className="absolute inset-0 bg-black/60" />

      <div className="relative z-10 w-full max-w-md mx-4">
        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-8 shadow-2xl">

          {!sent ? (
            <>
              <div className="text-center mb-8">
                <div className="w-14 h-14 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Mail className="text-blue-300" size={26} />
                </div>
                <h1 className="text-2xl font-bold text-white">Forgot Password?</h1>
                <p className="text-white/60 mt-2 text-sm">Enter your email and we'll send you a reset link</p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <Input
                  type="email"
                  placeholder="Your registered email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="bg-white/10 border-white/20 text-white placeholder:text-white/40 h-11"
                  autoFocus
                  data-testid="forgot-email-input"
                />
                <Button
                  type="submit"
                  disabled={loading}
                  className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white font-semibold"
                  data-testid="forgot-submit-btn"
                >
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center py-4">
              <CheckCircle className="text-green-400 mx-auto mb-4" size={48} />
              <h2 className="text-xl font-bold text-white mb-2">Check your inbox</h2>
              <p className="text-white/60 text-sm">
                If <strong className="text-white">{email}</strong> is registered, you'll receive a reset link shortly.
              </p>
              <p className="text-white/40 text-xs mt-3">Check your spam folder if you don't see it.</p>
            </div>
          )}

          <div className="mt-6 text-center">
            <Link to="/" className="inline-flex items-center gap-1.5 text-white/50 hover:text-white text-sm transition-colors">
              <ArrowLeft size={14} /> Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
